import { type Enum } from '@webapp/infrastructure/types/Enum'

// Discriminates the parameterized Terms & Methods section (3 tabs, one feature slice).
// Collapses the Angular route params :type (terms|methods) + :value (shipping|payment).
export const TermsMethodsKinds = {
  SHIPPING_TERMS: 'shipping-terms',
  PAYMENT_TERMS: 'payment-terms',
  SHIPPING_METHODS: 'shipping-methods',
} as const

export type TermsMethodsKindEnum = Enum<typeof TermsMethodsKinds>
